import React from 'react';

import { Body, Modal, Title } from '@icarros/ids-react';

import { ReactComponent as NPSIllustration } from '../../../assets/rebranding/institucional/depoimentos.svg';

import { ModalBody } from './style';

interface FeedbackSuccessProps {
  modalOpen: boolean;
  handleClose: () => void;
}

export function FeedbackSuccess({ modalOpen, handleClose }: FeedbackSuccessProps): JSX.Element {
  return (
    <Modal
      stateOpen={[
        modalOpen,
        () => {
          handleClose();
        }
      ]}
      body={
        <ModalBody>
          <NPSIllustration />
          <Title variant="default" size="base">
            agradecemos o seu feedback
          </Title>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            Com a sua ajuda conseguimos melhorar cada vez mais nossos serviços.
          </Body>
        </ModalBody>
      }
      title=""
      mainButtonText="fechar"
      mainButtonMethod={() => {
        handleClose();
      }}
    />
  );
}
